var _path, _circle, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.018 61.956 75 56.434V51.63l-4.922-5.009H50.2l-4.615 4.72v3.908",
    stroke: "currentColor",
    strokeWidth: 3.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.373,
    cy: 32.578,
    r: 8.176,
    stroke: "currentColor",
    strokeWidth: 3.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.194 53.25H25.506l-4.922 5.01v4.803l7.983 5.523",
    stroke: "currentColor",
    strokeWidth: 3.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.694,
    cy: 37.848,
    r: 8.031,
    stroke: "currentColor",
    strokeWidth: 3.2
  })));
};
export default SvgUsers;